import { Header } from 'components/header/Header'
import React, { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

function Layout(props: Props) {
  const { children } = props

  return (
    <>
      <Header />
      {children}
    </>
  )
}

export default Layout
